import { ChevronUp } from 'lucide-react';

import useJobQuoteCompact from './useJobQuoteCompact';

import JobQuoteBreakdown from '../JobQuoteBreakdown';
import JobQuoteHeader from '../JobQuoteHeader';
import JobQuotePrices from '../JobQuotePrices';

const JobQuoteCompact: React.FunctionComponent = function () {
  const { open, collapseRef, onClick, contentStyle } = useJobQuoteCompact();
  return (
    <div className="flex flex-col">
      <JobQuoteHeader onClick={onClick} open={open} />
      <div
        className="overflow-hidden border-b border-neutral-200"
        style={contentStyle}
      >
        <div className="flex flex-col bg-neutral-000" ref={collapseRef}>
          <JobQuoteBreakdown />
          <JobQuotePrices />
          <button
            type="button"
            id="job-quote-collapse-close"
            onClick={onClick}
            className="flex flex-row gap-x-3 px-4 py-2 mx-auto rounded hover:bg-neutral-200 mb-3 text-neutral-600 text-12-18"
          >
            <p>Hide Details</p>
            <ChevronUp size={20} className="my-auto" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobQuoteCompact;
